import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-loader-map',
  templateUrl: './loader-map.component.html',
  styleUrls: ['./loader-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderMapComponent{

}
